// removed by extract-text-webpack-plugin
module.exports = {"emoji":"emoji__1jVRZ"};


//////////////////
// WEBPACK FOOTER
// ./components/Emoji/style.css
// module id = F+sh
// module chunks = 0